import { render, staticRenderFns } from "./nosotros.vue?vue&type=template&id=4fb3c7a8&scoped=true&"
import script from "./nosotros.vue?vue&type=script&lang=js&"
export * from "./nosotros.vue?vue&type=script&lang=js&"
import style0 from "./nosotros.vue?vue&type=style&index=0&id=4fb3c7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3c7a8",
  null
  
)

export default component.exports